import { render, staticRenderFns } from "./AboutChildSupportOrder.vue?vue&type=template&id=2b068ff7"
import script from "./AboutChildSupportOrder.vue?vue&type=script&lang=ts"
export * from "./AboutChildSupportOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports